import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param candidateData: object
// example:
// {
//   "full_name": "Rizaq Hummos"
// }
export function updateStudent(studentData: object): Promise<ApiResponse> {
  return Axios.put("v1/students/students", studentData);
}
export function getStudent(): Promise<ApiResponse> {
  return Axios.get("v1/students/students");
}

export function showStudentStatistics(): Promise<ApiResponse> {
  return Axios.get("v1/students/statistics");
}
